var _defs, _circle, _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg07HoldingNatureSingle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #042b62;\n      }\n\n      .cls-1, .cls-3, .cls-4, .cls-5 {\n        stroke: #000;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1, .cls-3, .cls-5 {\n        stroke-width: 15px;\n      }\n\n      .cls-3, .cls-4 {\n        fill: none;\n      }\n\n      .cls-4 {\n        stroke-width: 24px;\n      }\n\n      .cls-6 {\n        fill: #232323;\n      }\n\n      .cls-5 {\n        fill: #fff;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 539.5,
    cy: 539.5,
    r: 408.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M534,534.08s-112.04,1.78-90.27-124.33c0,0,86.19,2.72,134.27-34.47,0,0,11.79,21.77,44.45,35.38,0,0,29.03,111.66-88.45,123.42Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M440.56,409.3s-26.31-3.63-24.49,20.87c0,0-3.63,25.09,24.49,23.89v-44.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M625.63,412.02s26.31-3.63,24.49,20.87c0,0,3.63,25.09-24.49,23.89v-44.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M441.12,412.75s79.92,2.4,129.44-31.5c0,0,30.5,38.69,53.98,38.55,0,0,15.18-109.94-85.29-117.1,0,0-90.66-16.33-98.13,110.06Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M657.83,602.08v127.92h-255.83v-121.57s0-38.1,42.64-40.82h43.8s16.08,28.18,43.75,31.33c0,0,25.84,1.33,41.72-31.33h28.49s49.09-3.63,55.44,34.47Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M536.41,598.64c21.81-2.13,37.5-31.03,37.5-31.03-14.98-13.61-11.14-38.16-11.14-38.16-34.28,9.92-58.48,0-58.48,0,7.94,19.9-15.85,38.16-15.85,38.16-4.79-5.44,18.17,33.94,47.97,31.03Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 436.47,
    y: 689.18,
    width: 46.27,
    height: 36.29
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 436.47,
    y: 689.18,
    width: 46.27,
    height: 9.07
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg07HoldingNatureSingle);
export default __webpack_public_path__ + "static/media/07_holding_nature_single.bd7259f1f35c9115925d3d321315e907.svg";
export { ForwardRef as ReactComponent };